import React from 'react';
import { ClockIcon, CompassIcon, FolderCheckIcon, HeartHandshakeIcon, UsersIcon } from 'lucide-react';
import { benefits } from '../data/content';
const icons = {
  hours: ClockIcon,
  next: CompassIcon,
  organized: FolderCheckIcon,
  ages: UsersIcon,
  therapy: HeartHandshakeIcon
};
export function Benefits() {
  return <section className="bg-sage-light py-10 sm:py-14" aria-labelledby="benefits-title" data-id="element-17" data-mp="3vq7bdjawmakb">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-18" data-mp="3qsf9pxkgja2x">
        <h2 id="benefits-title" className="text-center font-display text-[24px] font-semibold uppercase tracking-tightish text-navy-deep sm:text-3xl" data-id="element-19" data-mp="3mqah925qwjhv">
          What changes in your week?
        </h2>

        <ul className="mt-5 divide-y divide-navy/10 sm:mt-7" data-id="element-20" data-mp="3cswe248u1r7i">
          {benefits.map(benefit => {
          const Icon = icons[benefit.icon];
          return <li key={benefit.title} className="flex items-start gap-3 py-3 sm:py-3.5" data-id="element-21" data-mp="1b0rhgfge25qg">
                <Icon className="mt-0.5 h-[18px] w-[18px] shrink-0 text-teal sm:h-5 sm:w-5" aria-hidden="true" data-id="element-22" data-mp="2rg0hl2du0ov" />
                <div data-id="element-23" data-mp="6u4bnzekjjp0">
                  <h3 className="text-[13.5px] font-semibold uppercase leading-tight tracking-[0.03em] text-navy-deep sm:text-[15px]" data-id="element-24" data-mp="3oye98gxr5268">
                    {benefit.title}
                  </h3>
                  <p className="mt-0.5 text-[12.5px] leading-snug text-navy-soft sm:text-sm" data-id="element-25" data-mp="3tzc15l8kdakx">
                    {benefit.detail}
                  </p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}